import React, {Component} from 'react'
// import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
// import config from '../utils/siteConfig'
import HeaderSmall from '../components/HeaderSmall'
import styled from "styled-components";
import Img from "gatsby-image";
import Container from "../components/Container";
import Cta from "../components/Cta";
import Footer from "../components/Footer";

const Wrapper = styled.div``;
const TextContainer = styled.div`
  p {
    line-height: 1.5;
    color: ${props => props.theme.colors.base};
    margin-bottom: 2rem;

    > p {
      border-left: none;
      padding-left: none;
      max-width: none;
    }
  }
`;

const ContentWrapper = styled.div`
  @media (min-width: ${props => props.theme.responsive.small}) {
    padding: 3em 6em;
  }
`;

const ImageWrapper = styled.figure`
  box-shadow: -6px 8px 25px 0 rgba(0, 0, 0, 0.5);
  z-index: 1;
  width: 100%;
  position: relative;
  margin-bottom: 2em;

  img {
    object-fit: ${props => props.fit || "cover"} !important;
    object-position: ${props => props.position || "50% 50%"} !important;
    font-family: 'object-fit: ${props =>
  props.fit || "cover"} !important; object-position: ${props =>
  props.position || "50% 50%"} !important;'
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.theme.colors.secondary};
    mix-blend-mode: multiply;
    opacity: 0;

    @supports (mix-blend-mode: multiply) {
      opacity: 1;
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.theme.colors.black};
    mix-blend-mode: screen;
    opacity: 0.5;
    z-index: 1;

    @supports (mix-blend-mode: multiply) {
      opacity: 1;
    }
  }

  div {
    height: 100%;
  }
`;

class PostTemplate extends React.Component {
  state = {
    aboutActive: null
  };

  componentDidMount() {
    this.setState({
      aboutActive: window.innerWidth < 800 ? false : true
    })
  }

  render() {
    const {data} = this.props;
    const {
      title,
      metaDescription,
      body,
      bodyBottom,
      detailImage
    } = data.contentfulPost;

    const header = data.allContentfulHeader.edges;
    const cta = data.allContentfulCta.edges;
    const posts = data.allContentfulPost.edges;

    return (
      <Wrapper>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={metaDescription}/>
        </Helmet>


        <HeaderSmall header={header} title={title} aboutActive={this.state.aboutActive} aboutDetailLinks={posts.map(post => (
          { slug: post.node.slug, title: post.node.menuTitle }
        ))}/>

        <Container>
          <ContentWrapper>
            <TextContainer dangerouslySetInnerHTML={{ __html: body.childMarkdownRemark.html }}/>
          </ContentWrapper>

          <ImageWrapper>
            <Img sizes={detailImage.sizes} alt={detailImage.title} backgroundColor={"#eeeeee"}/>
          </ImageWrapper>

          {bodyBottom && (
            <ContentWrapper>
              <TextContainer dangerouslySetInnerHTML={{ __html: bodyBottom.childMarkdownRemark.html }}/>
            </ContentWrapper>
          )}

        </Container>

        {cta && (
          <Cta cta={cta}/>
        )}

        <Footer/>

      </Wrapper>
    )
  }
};

export const pageQuery = graphql`
  query postQuery($slug: String!) {
    contentfulPost(slug: { eq: $slug }) {
      title
      id
      slug
      metaDescription
      detailImage {
        title
        sizes(maxWidth: 800) {
          ...GatsbyContentfulSizes_withWebp_noBase64
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
      bodyBottom {
        childMarkdownRemark {
          html
        }
      }
    }
    allContentfulPost(limit: 5) {
      edges {
        node {
          slug
          menuTitle
        }
      }
    }
    allContentfulHeader(limit: 1) {
      edges {
        node {
          home
          about
          features
          contact
          login
          loginLink
          loginIcon {
            sizes {
              ...GatsbyContentfulSizes_withWebp_noBase64
            }
          }
          backgroundImageSmall {
            title
            sizes(maxWidth: 800) {
              ...GatsbyContentfulSizes_withWebp_noBase64
            }
          }
        }
      }
    }
    allContentfulCta(limit: 1) {
      edges {
        node {
          title
          buttonText
          buttonUrl {
            childMarkdownRemark {
              rawMarkdownBody
            }
          }
        }
      }
    }
  }
`;

export default PostTemplate



// WEBPACK FOOTER //
// ./src/templates/feature.js